// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { blue, green, orange } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Setup menu items
const setupMenus = [
  {
    title: "Pending Variations",
    description:
      "Approvers see pending variations across all categories (single entry, loaders, temporary stoppage).",
    icon: "assignment",
    color: blue[500],
    route: "/variations/review/pending",
  },
  {
    title: "Approve Variation",
    description: "Bulk approve or individual approve variations.",
    icon: "check_circle",
    color: green[500],
    route: "/variations/review/approve",
  },
  // {
  //   title: "View Change Details",
  //   description: "View change details (old vs new value, reason, uploaded authority).",
  //   icon: "visibility",
  //   color: orange[500],
  //   route: "/hr/employees/add-edit",
  // },
];

function SetupMenu() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={4}>
        <Grid container spacing={3}>
          {setupMenus.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  transition: "0.3s",
                  "&:hover": { boxShadow: 8, transform: "translateY(-4px)" },
                }}
              >
                <CardActionArea onClick={() => navigate(item.route)}>
                  <CardContent>
                    <MDBox display="flex" alignItems="center" mb={2}>
                      <Avatar
                        sx={{
                          bgcolor: item.color,
                          width: 50,
                          height: 50,
                          mr: 2,
                        }}
                      >
                        <Icon sx={{ color: "#fff" }}>{item.icon}</Icon>
                      </Avatar>
                      <Typography variant="h6" fontWeight="medium">
                        {item.title}
                      </Typography>
                    </MDBox>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SetupMenu;
